import script from "./shift-scheduling2.vue?vue&type=script&setup=true&lang=js"
export * from "./shift-scheduling2.vue?vue&type=script&setup=true&lang=js"

import "./shift-scheduling2.vue?vue&type=style&index=0&id=7d7d0673&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d7d0673"]])

export default __exports__